import React from 'react';
import cx from 'classnames';
import States from '../misc/States.js';
import scrollToErroredControls from '../misc/scrollToErroredControls.js';
import * as util from '../util.js';
import './NewRepForm.css';

class NewRepForm extends React.Component {
  constructor(props) {
    super(props);
    this._form = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.submissionCount > prevProps.submissionCount) {
      if (Object.keys(this.props.errors).length > 0) {
        scrollToErroredControls(this._form.current);
      }
    }
  }

  _address1Changed = (event) => {
    this.props.onParamChanged('address1', event.target.value);
  };

  _address2Changed = (event) => {
    this.props.onParamChanged('address2', event.target.value);
  };

  _birthdateChanged = (value) => {
    this.props.onParamChanged('birthdate', value);
  };

  _childrenSportsChanged = (event) => {
    this.props.onParamChanged('childrenSports', event.target.value);
  };

  _cityChanged = (event) => {
    this.props.onParamChanged('city', event.target.value);
  };

  _emailChanged = (event) => {
    this.props.onParamChanged('email', event.target.value);
  };

  _excitesChanged = (event) => {
    this.props.onParamChanged('excites', event.target.value);
  };

  _firstNameChanged = (event) => {
    this.props.onParamChanged('firstName', event.target.value);
  };

  _fundraisingExperienceChanged = (event) => {
    this.props.onParamChanged('fundraisingExperience', event.target.value);
  };

  _lastNameChanged = (event) => {
    this.props.onParamChanged('lastName', event.target.value);
  };

  _myScheduleChanged = (event) => {
    this.props.onParamChanged('mySchedule', event.target.value);
  };

  _paramChanged = (event) => {
    this.props.onParamChanged(event.target.name, event.target.value);
  };

  _phoneChanged = (event) => {
    this.props.onParamChanged('phone', event.target.value);
  };

  _positionChecked = (position) => {
    return this.props.params.positionTypes.indexOf(position) >= 0;
  };

  _positionTypeChanged = (event) => {
    const position = event.target.value;
    const positions = this.props.params.positionTypes.slice(0);
    const idx = positions.indexOf(position);
    if (idx >= 0) {
      positions.splice(idx, 1);
    } else {
      positions.push(position);
    }
    this.props.onParamChanged('positionTypes', positions);
  };

  _positionTypeSwitched = (event) => {
    const position = event.target.value;
    this.props.onParamChanged('positionTypes', [position]);
  };

  _salesExperienceDescriptionChanged = (event) => {
    this.props.onParamChanged('salesExperienceDescription', event.target.value);
  };

  _sportCoachedChanged = (event) => {
    this.props.onParamChanged('sportCoached', event.target.value);
  };

  _sportPlayedChanged = (event) => {
    this.props.onParamChanged('sportPlayed', event.target.value);
  };

  _sportTrainedChanged = (event) => {
    this.props.onParamChanged('sportTrained', event.target.value);
  };

  _stateChanged = (event) => {
    this.props.onParamChanged('state', event.target.value);
  };

  _teamManagementUsedChanged = (event) => {
    this.props.onParamChanged('teamManagementUsed', event.target.value);
  };

  _teamRelationshipsChanged = (event) => {
    this.props.onParamChanged('teamRelationships', event.target.value);
  };

  _toggleCurrentlyCoaching = (event) => {
    if (this.props.params.currentlyCoaching) {
      this.props.onParamChanged('currentlyCoaching', false);
    } else {
      this.props.onParamChanged('currentlyCoaching', true);
    }
  };

  _toggleField = (field, event) => {
    if (event.target.value === 'on') {
      this.props.onParamChanged(field, true);
    } else if (event.target.value === 'off') {
      this.props.onParamChanged(field, false);
    } else if (this.props.params[field]) {
      this.props.onParamChanged(field, false);
    } else {
      this.props.onParamChanged(field, true);
    }
  };

  _toggleParam = (event) => {
    const name = event.target.name;
    this.props.onParamToggled(name);
  };

  _toggleSalesExperience = (event) => {
    this._toggleField('salesExperience', event);
  };

  _toggleWillingToColdCall = (event) => {
    this._toggleField('willingToColdCall', event);
  };

  _toggleWillingToNetwork = (event) => {
    this._toggleField('willingToNetwork', event);
  };

  _toggleWillingToUseBlastFundraising = (event) => {
    this._toggleField('willingToUseBlastFundraising', event);
  };

  _toggleWorkedFromHome = (event) => {
    this._toggleField('workedFromHome', event);
  };

  _whyIsBlastBetterChanged = (event) => {
    this.props.onParamChanged('whyIsBlastBetter', event.target.value);
  };

  _zipChanged = (event) => {
    this.props.onParamChanged('zip', event.target.value);
  };

  render() {
    const {errors, failed, params} = this.props;
    let spinner = null;
    if (this.props.failed) {
      spinner = (<div className="btn-txt text-danger">There was an error.</div>);
    } else if (this.props.submitting) {
      spinner = (<div className="btn-txt loading-gif"></div>);
    }
    const techRatingInputProps = {
      type: 'number',
      className: 'form-control',
      pattern: '[0-9]*',
      min: '1',
      max: '10',
      size: '2',
      step: '1',
      onKeyPress: util.blockNonDigits,
      onChange: this._paramChanged,
    };
    return (
      <form ref={this._form} onSubmit={this.props.onSubmit}>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className={cx('form-group', {'has-error': errors.firstName})}>
              <label className="control-label">
                First Name
              </label>
              <div>
                <input type="text" className="form-control" autoFocus maxLength="200" required value={params.firstName} onChange={this._firstNameChanged} />
              </div>
              <div className="help-block help-block--shownOnlyWithStatus">
                {errors.firstName}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className={cx('form-group', {'has-error': errors.lastName})}>
              <label className="control-label">
                Last Name
              </label>
              <div>
                <input type="text" className="form-control" maxLength="200" required value={params.lastName} onChange={this._lastNameChanged} />
              </div>
              <div className="help-block help-block--shownOnlyWithStatus">
                {errors.lastName}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className={cx('form-group', {'has-error': errors.email})}>
              <label className="control-label">
                Email
              </label>
              <div>
                <input type="email" className="form-control" maxLength="200" required value={params.email} onChange={this._emailChanged} />
              </div>
              <div className="help-block help-block--shownOnlyWithStatus">
                {errors.email}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className={cx('form-group', {'has-error': errors.phone})}>
              <label className="control-label">
                Phone
              </label>
              <div>
                <input type="text" className="form-control" maxLength="200" required value={params.phone} onChange={this._phoneChanged} />
              </div>
              <div className="help-block help-block--shownOnlyWithStatus">
                {errors.phone}
              </div>
            </div>
          </div>
        </div>

        <div className={cx('form-group', {'has-error': errors.address1})}>
          <label className="control-label">
            Address
          </label>
          <div>
            <input type="text" className="form-control" maxLength="200" value={params.address1} onChange={this._address1Changed} placeholder="Optional" />
          </div>
          <div className="help-block help-block--shownOnlyWithStatus">
            {errors.address1}
          </div>
        </div>

        <div className={cx('form-group', {'has-error': errors.address2})}>
          <div>
            <input type="text" className="form-control" maxLength="200" value={params.address2} onChange={this._address2Changed} />
          </div>
          <div className="help-block help-block--shownOnlyWithStatus">
            {errors.address2}
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className={cx('form-group', {'has-error': errors.city})}>
              <label className="control-label">
                City
              </label>
              <div>
                <input type="text" className="form-control" maxLength="200" required value={params.city} onChange={this._cityChanged} />
              </div>
              <div className="help-block help-block--shownOnlyWithStatus">
                {errors.city}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className={cx('form-group', {'has-error': errors.state})}>
              <label className="control-label">
                State
              </label>
              <select className="form-control" name="state" required value={params.search_state} onChange={this._stateChanged} >
                <option value="">--</option>
                {
                  States['US'].map(([value, label]) => (<option key={value} value={value}>{label}</option>))
                }
              </select>
              <div className="help-block help-block--shownOnlyWithStatus">
                {errors.state}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className={cx('form-group', {'has-error': errors.zip})}>
              <label className="control-label">
                Zip
              </label>
              <div>
                <input type="tel" className="form-control" maxLength="9" required value={params.zip} onChange={this._zipChanged} />
              </div>
              <div className="help-block help-block--shownOnlyWithStatus">
                {errors.zip}
              </div>
            </div>
          </div>
        </div>

        <div className={cx('form-group', {'has-error': errors.positionTypes})}>
          <label className="control-label">
            Applying for
          </label>
          <div className="radio">
            <label>
              <input type="radio" name="positionType" value="campus_coordinator" required checked={this._positionChecked('campus_coordinator')} onChange={this._positionTypeSwitched} /> Campus Coordinator
            </label>
          </div>
          <div className="radio">
            <label>
              <input type="radio" name="positionType" value="outside_rep" required checked={this._positionChecked('outside_rep')} onChange={this._positionTypeSwitched} /> Outside Rep (1099)
            </label>
          </div>
          <div className="radio">
            <label>
              <input type="radio" name="positionType" value="inside_rep" required checked={this._positionChecked('inside_rep')} onChange={this._positionTypeSwitched} /> Inside Rep (Santa Ana, CA)
            </label>
          </div>
{/*
          <div className="row">
            <div className="col-xs-6">
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="positionTypes" value="weekend_work" checked={this._positionChecked('weekend_work')} onChange={this._positionTypeChanged} /> Weekend Work
                </label>
              </div>
            </div>

            <div className="col-xs-6">
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="positionTypes" value="game_filmer" checked={this._positionChecked('game_filmer')} onChange={this._positionTypeChanged} /> Game Filmer
                </label>
              </div>
            </div>

            <div className="col-xs-6">
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="positionTypes" value="full_time_rep" checked={this._positionChecked('full_time_rep')} onChange={this._positionTypeChanged} /> Full Time Rep
                </label>
              </div>
            </div>

            <div className="col-xs-6">
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="positionTypes" value="part_time_rep" checked={this._positionChecked('part_time_rep')} onChange={this._positionTypeChanged} /> Part Time Rep
                </label>
              </div>
            </div>

            <div className="col-xs-6">
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="positionTypes" value="referral_ambassador" checked={this._positionChecked('referral_ambassador')} onChange={this._positionTypeChanged} /> Referral Ambassador
                </label>
              </div>
            </div>

            <div className="col-xs-6">
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="positionTypes" value="refer_an_ambassador" checked={this._positionChecked('refer_an_ambassador')} onChange={this._positionTypeChanged} /> $250 Refer an Ambassador
                </label>
              </div>
            </div>
          </div>

          <div>
            <a href="/training/job_description" target="_blank">
              View Job Descriptions
            </a>
          </div>
*/}
        </div>
{/*
        <div className={cx('form-group', {'has-error': errors.lawEnforcement})}>
          <label className="control-label">
            Are you a Law Enforcement Officer?
          </label>
          <div>
            <div className="radio-inline">
              <label style={{fontWeight: 'normal'}}><input type="radio" name="lawEnforcement" checked={params.lawEnforcement} onChange={this._toggleParam} /> Yes</label>
            </div>
            <div className="radio-inline">
              <label style={{fontWeight: 'normal'}}><input type="radio" name="lawEnforcement" checked={!params.lawEnforcement} onChange={this._toggleParam} /> No</label>
            </div>
          </div>
        </div>
*/}
        {
          params.lawEnforcement ? (
            <div className={cx('form-group', {'has-error': errors.lawEnforcementRetired})}>
              <label className="control-label">
                If yes, are you retired?
              </label>
              <div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="lawEnforcementRetired" checked={params.lawEnforcementRetired} onChange={this._toggleParam} /> Yes</label>
                </div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="lawEnforcementRetired" checked={!params.lawEnforcementRetired} onChange={this._toggleParam} /> No</label>
                </div>
              </div>
            </div>
          ): null
        }

        {
          params.lawEnforcement ? (
            <div className={cx('form-group', {'has-error': errors.lawEnforcementAgency})}>
              <label className="control-label">
                Which agency?
              </label>
              <input type="text" className="form-control" name="lawEnforcementAgency" maxLength="255" value={params.lawEnforcementAgency} onChange={this._paramChanged} />
            </div>
          ) :null
        }

        <div className={cx('form-group', {'has-error': errors.shirtSize})}>
          <label className="control-label">
            Shirt Size
          </label>
          <input type="text" className="form-control" name="shirtSize" value={params.shirtSize} onChange={this._paramChanged} placeholder="ex: Men's L, Women's M, etc" maxLength="255" />
        </div>

        <hr />

        <div className="NewRepFormSectionHeader">
          <div className="NewRepFormSectionHeader-title">Sports &amp; Relationships</div>
          <div className="NewRepFormSectionHeader-subtitle">(no experience required)</div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                What sports have you played? (include highest level)
              </label>
              <div>
                <input type="text" className="form-control" maxLength="200" value={params.sportPlayed} onChange={this._sportPlayedChanged} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                What sports have you coached? (include all levels)
              </label>
              <div>
                <input type="text" className="form-control" maxLength="200" value={params.sportCoached} onChange={this._sportCoachedChanged} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                Are you currently coaching?
              </label>
              <div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="currentlyCoaching" checked={params.currentlyCoaching} onChange={this._toggleCurrentlyCoaching} /> Yes</label>
                </div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="currentlyCoaching" checked={!params.currentlyCoaching} onChange={this._toggleCurrentlyCoaching} /> No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                Sports and levels of athletes you have trained?
              </label>
              <div>
                <input type="text" className="form-control" maxLength="200" value={params.sportTrained} onChange={this._sportTrainedChanged} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                Do you have any children that currently play sports? If so, what sports and levels?
              </label>
              <div>
                <input type="text" className="form-control" maxLength="200" value={params.childrenSports} onChange={this._childrenSportsChanged} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                List any high schools, colleges, clubs or teams you have a relationship with (specific sports when applicable)
              </label>
              <div>
                <textarea
                  className="form-control"
                  style={{minHeight: '10em'}}
                  value={params.teamRelationships}
                  onChange={this._teamRelationshipsChanged} />
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="NewRepFormSectionHeader">
          <div className="NewRepFormSectionHeader-title">Sales Experience</div>
          <div className="NewRepFormSectionHeader-subtitle">(no experience required)</div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                Have you ever worked in sales?
              </label>
              <div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="salesExperience" required checked={params.salesExperience === true} value="on" onChange={this._toggleSalesExperience} /> Yes</label>
                </div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="salesExperience" required checked={params.salesExperience === false} value="off" onChange={this._toggleSalesExperience} /> No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          params.salesExperience ? (
            <div className="row">
              <div className="col-xs-12">
                <div className="form-group">
                  <label className="control-label">
                    If yes, briefly describe what you sold and how you found clients.
                  </label>
                  <div>
                    <textarea
                      className="form-control"
                      style={{minHeight: '10em'}}
                      value={params.salesExperienceDescription}
                      onChange={this._salesExperienceDescriptionChanged} />
                  </div>
                </div>
              </div>
            </div>

          ): null
        }

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                Have you ever worked from home?
              </label>
              <div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="workedFromHome" required checked={params.workedFromHome === true} value="on" onChange={this._toggleWorkedFromHome} /> Yes</label>
                </div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="workedFromHome" required checked={params.workedFromHome === false} value="off" onChange={this._toggleWorkedFromHome} /> No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                Are you willing to cold call teams, schools and/or organizations?
              </label>
              <div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="willingToColdCall" required checked={params.willingToColdCall === true} value="on" onChange={this._toggleWillingToColdCall} /> Yes</label>
                </div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="willingToColdCall" required checked={params.willingToColdCall === false} value="off" onChange={this._toggleWillingToColdCall} /> No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                Are you willing to market our fundraising platform to your personal network?
              </label>
              <div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="willingToNetwork" required checked={params.willingToNetwork === true} value="on" onChange={this._toggleWillingToNetwork} /> Yes</label>
                </div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="willingToNetwork" required checked={params.willingToNetwork === false} value="off" onChange={this._toggleWillingToNetwork} /> No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
              Do you think you could convince teams to use Blast's fundraising platform?
              </label>
              <div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="willingToUseBlastFundraising" required checked={params.willingToUseBlastFundraising === true} value="on" onChange={this._toggleWillingToUseBlastFundraising} /> Yes</label>
                </div>
                <div className="radio-inline">
                  <label style={{fontWeight: 'normal'}}><input type="radio" name="willingToUseBlastFundraising" required checked={params.willingToUseBlastFundraising === false} value="off" onChange={this._toggleWillingToUseBlastFundraising} /> No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                How many hours per week can you commit to Blast? Describe your schedule
              </label>
              <div>
                <textarea
                  className="form-control"
                  style={{minHeight: '10em'}}
                  value={params.mySchedule}
                  onChange={this._myScheduleChanged} />
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="NewRepFormSectionHeader">
          <div className="NewRepFormSectionHeader-title">Technology</div>
        </div>

        <div className="form-horizontal">
          <p>
            <strong>On a scale of 1-10, rate your ability to use the following</strong> (1 being not at all, 10 being pro):
          </p>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                Facebook
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingFacebook" {...techRatingInputProps} value={params.techRatingFacebook} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                X (formerly Twitter)
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingTwitter" {...techRatingInputProps} value={params.techRatingTwitter} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                Shutterfly Team Sites
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingShutterfly" {...techRatingInputProps} value={params.techRatingShutterfly} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                Snap Mobile
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingTeamsnap" {...techRatingInputProps} value={params.techRatingTeamsnap} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                YouTube (posting videos)
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingYoutube" {...techRatingInputProps} value={params.techRatingYoutube} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                Snapchat
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingSnapchat" {...techRatingInputProps} value={params.techRatingSnapchat} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                TikTok
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingTikTok" {...techRatingInputProps} value={params.techRatingTikTok} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                iPhone
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingIphone" {...techRatingInputProps} value={params.techRatingIphone} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                Android Smart Phone
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingAndroid" {...techRatingInputProps} value={params.techRatingAndroid} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                Google Sheets
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingGoogleSheets" {...techRatingInputProps} value={params.techRatingGoogleSheets} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                GoFundMe
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingGofundme" {...techRatingInputProps} value={params.techRatingGofundme} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                Kickstarter
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingKickstarter" {...techRatingInputProps} value={params.techRatingKickstarter} />
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-9 col-sm-10">
              <div className="form-control-static">
                LinkedIn
              </div>
            </div>
            <div className="col-xs-3 col-sm-2">
              <input name="techRatingLinkedIn" {...techRatingInputProps} value={params.techRatingLinkedIn} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                What team management software, if any, have you personally used?
              </label>
              <div>
                <textarea
                  className="form-control"
                  style={{minHeight: '10em'}}
                  value={params.teamManagementUsed}
                  onChange={this._teamManagementUsedChanged} />
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="NewRepFormSectionHeader">
          <div className="NewRepFormSectionHeader-title">Fundraising</div>
          <div className="NewRepFormSectionHeader-subtitle">(no experience required)</div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                List and describe the sports fundraisers you have been a part of.
              </label>
              <div>
                <textarea
                  className="form-control"
                  style={{minHeight: '10em'}}
                  value={params.fundraisingExperience}
                  onChange={this._fundraisingExperienceChanged} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                What makes Blast Athletics fundraising system better than what is currently available to teams and schools?
              </label>
              <div>
                <textarea
                  className="form-control"
                  style={{minHeight: '10em'}}
                  value={params.whyIsBlastBetter}
                  onChange={this._whyIsBlastBetterChanged} />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">
                What excites you about being a Blast Rep?
              </label>
              <div>
                <textarea
                  className="form-control"
                  style={{minHeight: '10em'}}
                  value={params.excites}
                  onChange={this._excitesChanged} />
              </div>
            </div>
          </div>
        </div>

        <div className="NewRepFormSectionHeader">
          <div className="NewRepFormSectionHeader-title">Social Media</div>
          <div className="NewRepFormSectionHeader-subtitle">Paste links to Your Social Media Profiles</div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">Facebook</label>
              <input type="text" className="form-control" name="facebookProfileUrl" value={params.facebookProfileUrl} onChange={this._paramChanged} />
            </div>

            <div className="form-group">
              <label className="control-label">Instagram</label>
              <input type="text" className="form-control" name="instagramProfileUrl" value={params.instagramProfileUrl} onChange={this._paramChanged} />
            </div>

            <div className="form-group">
              <label className="control-label">Twitter</label>
              <input type="text" className="form-control" name="twitterProfileUrl" value={params.twitterProfileUrl} onChange={this._paramChanged} />
            </div>

            <div className="form-group">
              <label className="control-label">LinkedIn</label>
              <input type="text" className="form-control" name="linkedinProfileUrl" value={params.linkedinProfileUrl} onChange={this._paramChanged} />
            </div>
          </div>
        </div>

        <hr />

        <div className="form-group clearfix">
          <div className="pull-right">
            <button className="btn btn-primary" disabled={this.props.submitting}>Submit</button>
          </div>
          {spinner}
        </div>
      </form>
    );
  }
}

export default NewRepForm;
